import { Component, Inject, OnInit } from "@angular/core";
import { Command, LabelCommand } from "@tylertech/commands-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";
import { AugmentedModelObject } from "@tylertech/metadata-module";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { JournalEntryService } from "../../services";
export interface JournalEntryReceiptDialogData
{
    readonly JEReceipt: AugmentedModelObject;
}
@Component({
    selector: "journal-entry-receipt-dialog-component",
    templateUrl: "./journalEntryReceiptDialog.tmpl.html",
    standalone: false
})
export class JournalEntryReceiptDialogComponent implements OnInit
{
    readonly commands: ReadonlyArray<Command>;
    isLoaded: boolean;
    journalEntryCashTransactionsMetadata: ClassMetadata;
    journalEntryReceiptMetadata: ClassMetadata;
    metadataModel: AugmentedModelObject;
    constructor(
        private readonly dialogRef: MatDialogRef<JournalEntryReceiptDialogComponent, AugmentedModelObject | void>,
        @Inject(MAT_DIALOG_DATA)
        private readonly data: JournalEntryReceiptDialogData,
        private readonly $glJournalEntryService: JournalEntryService
    )
    {
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => this.dialogRef.close(),
                getEnabled: () => true,
            }),
            new LabelCommand({
                label: "Save",
                action: () => this.saveReceipt(),
                getEnabled: () => true,
            }),
        ];
    }

    private get JEReceipt(): AugmentedModelObject
    {
        return this.data.JEReceipt;
    }

    ngOnInit(): void
    {
        this.metadataModel = Object.assign({}, this.JEReceipt) as AugmentedModelObject;
        Promise.all([
            this.$glJournalEntryService.GetGLJournalEntryDistributionReceiptViewMetadata().then(metadata =>
            {
                this.journalEntryReceiptMetadata = metadata;
            }),
            this.$glJournalEntryService.GetGLJournalEntryDistributionCashTransactionsViewMetadata().then(metadata =>
            {
                this.journalEntryCashTransactionsMetadata = metadata;
            }),
        ]).finally(() =>
        {
            this.isLoaded = true;
        });
    }

    private saveReceipt(): void
    {
        this.dialogRef.close(this.metadataModel);
    }
}
